import TextLeftImageRight from './TextLeftImageRight.js';

export default TextLeftImageRight;